export const NO_DRIVER_OPTION_ID = "__no_driver__";

export type DriverGroupKey = "none" | "map" | "other";

export interface DriverSelectOption {
  id: string;
  label: string;
  groupKey: DriverGroupKey;
  nameForAssignment: string;
  enabled?: boolean;
  totalActiveOrders?: number;
}
